import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Button,
  Box,
} from "@mui/material";
import Card, { LoaderWrapper } from "../../../../components/Cards/Card";
import NativeObject from "../../../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../../../components/LayoutWrapper/LayoutWrapper";
import { useSelections } from "../../../../context/Selections";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { KpisAreaAtuacao } from "../../../../components/KPIsInsights/KPIsAreaAtuacao";
import CircleLoader from "../../../../components/Loaders/CircleLoader";

function InsightsGoldenDesktop({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setselectedValue] = useState("Cuidados com a pele");
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [textQuarter, setTextQuarter] = useState();
  const [textQuarterOne, setTextQuarterOne] = useState();
  const [textQuarterTwo, setTextQuarterTwo] = useState();
  const [textQuarterThree, setTextQuarterThree] = useState();
  const [textQuarterFoor, setTextQuarterFoor] = useState();
  const [showGraph, setShowGraph] = useState(false);

  function handleChange(value) {
    app.field("Agrp").selectMatch(value);
  }

  const fetchKPIValueShowGraph = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setShowGraph(value > 0 ? true : false);
        });
      }
    },
    [app, setTextQuarter]
  );

  const exportToXLS = async (objectId, isContainer) => {
    setLoadingExcel(true);
    let id = objectId;

    if (isContainer) {
      await app.visualization
        .get(objectId)
        .then((vis) => {
          id = vis.model.items.activeId;
        })
        .catch(() => setLoadingExcel(false));
    }

    if (app && id) {
      await app.visualization
        .get(id)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            const xlsLink = `https://qsense.mtrix.com.br${
              process.env.REACT_APP_PREFIX
            }${link.substring(link.indexOf("tempcontent"))}`;
            window.open(xlsLink);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  const fetchKPIValue = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          if (!position) {
            setTextQuarter(value && value[0] !== "-" ? value : null);
          } else {
            position === 1 &&
              setTextQuarterOne(value && value[0] !== "-" ? value : null);
            position === 2 &&
              setTextQuarterTwo(value && value[0] !== "-" ? value : null);
            position === 3 &&
              setTextQuarterThree(value && value[0] !== "-" ? value : null);
            position === 4 &&
              setTextQuarterFoor(value && value[0] !== "-" ? value : null);
          }
        });
      }
    },
    [app, setTextQuarter]
  );

  useEffect(() => {
    if (app) {
      const visaoField = selections.find((s) => s.qField === "Agrp");
      setselectedValue(visaoField?.qSelected);
      fetchKPIValue("jzfBCy");
      fetchKPIValue("HJmznE", 1);
      fetchKPIValue("aerRs", 2);
      fetchKPIValue("FZfyru", 3);
      fetchKPIValue("vrDEU", 4);

      fetchKPIValueShowGraph("mvhqEX");
    }
  }, [app, selections]);

  return (
    <div className="app insightstArea">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container width={"100%"}>
            <Grid className="container-line-one-insights">
              <span className="title-form"> Agrupamento estratégico </span>
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Cuidados com a Pele"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={(e) => handleChange(e.target.value)}
                  sx={{ marginLeft: "20px" }}
                >
                  <FormControlLabel
                    value="Cuidados com a Pele"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados com a pele"
                  />

                  <FormControlLabel
                    value="Esmaltes"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Esmaltes"
                  />

                  <FormControlLabel
                    value="Cuidados Pessoais"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados Pessoais"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid width={"100%"}>
              <Grid className="container-part-one-line-one-insights">
                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: `Quanto tempo falta para fechar ${textQuarter}?`,
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"d2322f69-b9fd-4c0a-b98b-48ddaa944328"}
                      idNumberSecond={"9c425b49-b696-4417-a808-f30b0068633f"}
                      idPercentageProgress={
                        "97fa3a6c-61b0-4e6b-b400-c08fa844f45b"
                      }
                      idNumberPercentage={
                        "97fa3a6c-61b0-4e6b-b400-c08fa844f45b"
                      }
                      days
                    />
                  </Card>
                </Grid>

                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Como estamos em relação à meta?",
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"2a1aa999-7eb2-43d3-a0e9-ed4bdc05350c"}
                      idNumberSecond={"aa4e8748-a340-40e5-a180-adfd431b88ea"}
                      idPercentageProgress={
                        "3a490bd8-9069-4020-9791-5134c00e2877"
                      }
                      idNumberPercentage={
                        "acb989e1-b5f0-4925-a5a9-502853b756a7"
                      }
                    />
                  </Card>
                </Grid>
              </Grid>

              {showGraph && (
                <Grid className="container-part-dois-line-two">
                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quantos distribuidores estão abaixo ou acima da meta?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="268bb5c2-e4a0-4b84-9cfc-c02911168f8a"
                      type={"table"}
                      reference={{
                        id: "268bb5c2-e4a0-4b84-9cfc-c02911168f8a",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",

                        width: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quais distribuidores puxam o resultado para baixo?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="d96303ed-fd15-47b0-b96a-b3c519413e1f"
                      type={"table"}
                      reference={{
                        id: "d96303ed-fd15-47b0-b96a-b3c519413e1f",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",
                        width: "100%",
                      }}
                    />
                  </Card>
                </Grid>
              )}
            </Grid>
            <Grid className="container-last-line-insights">
              {showGraph && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Performance",
                  }}
                >
                  <ul className="container-legenda">
                    <li className="text-quadrado">legenda</li>
                    <li>
                      <span className="quadrado sell"></span>
                      <span className="text-quadrado">
                        <span className="text">Sell out de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>

                    <li>
                      <span className="quadrado media"></span>
                      <span className="text-quadrado">
                        Média nos Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado maxima"></span>
                      <span className="text-quadrado">
                        Máxima realizada em Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado meta"></span>
                      <span className="text-quadrado">
                        <span className="text">Meta de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>
                  </ul>
                  <NativeObject
                    app={app}
                    key="4d330f81-a937-4d9e-b9be-f3280ec0503f"
                    type={"table"}
                    reference={{
                      id: "4d330f81-a937-4d9e-b9be-f3280ec0503f",
                    }}
                    style={{
                      padding: "0",
                      height: "300px",
                      width: "100%",
                    }}
                  />
                </Card>
              )}

              <Card
                app={app}
                header={{
                  hardTitle: "Onde atacar e o que vender",
                }}
              >
                <Grid className="container-last-line-objects">
                  <div>
                    <div className="container-line-export-button export-button-onde-atacar">
                      <Grid
                        className="container-periodo"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        xs
                      >
                        <p style={{ height: "30px" }}>
                          Não comprou em {textQuarterOne}, mas comprou em{" "}
                          {textQuarterTwo} e/ou {textQuarterThree} e/ou{" "}
                          {textQuarterFoor}
                        </p>
                      </Grid>

                      <Tooltip title="Exportar para Excel">
                        <Button
                          type="button"
                          onClick={() =>
                            exportToXLS(
                              "4d54ee53-716d-47b1-9c03-aff2db606775",
                              true
                            )
                          }
                          endIcon={<FileDownloadOutlinedIcon />}
                          className="export-button"
                        >
                          {!loadingExcel ? (
                            <Box component={"span"}>
                              Exportar Lista Completa
                            </Box>
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </Button>
                      </Tooltip>
                    </div>
                    <NativeObject
                      app={app}
                      key="4d54ee53-716d-47b1-9c03-aff2db606775"
                      type={"table"}
                      reference={{
                        id: "4d54ee53-716d-47b1-9c03-aff2db606775",
                      }}
                      style={{
                        padding: "0",
                        height: "360px",
                        width: "100%",
                      }}
                    />
                  </div>
                  <div>
                    <div className="container-line-export-button export-button-onde-atacar">
                      <Grid
                        className="container-periodo"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        xs
                      >
                        <p style={{ height: "30px" }}>
                          Comprou em {textQuarterOne}, mas abaixo de 30% da
                          média dos quarters anteriores ({textQuarterTwo} +{" "}
                          {textQuarterThree} + {textQuarterFoor})
                        </p>
                      </Grid>

                      <Tooltip title="Exportar para Excel">
                        <Button
                          type="button"
                          variant="outlined"
                          onClick={() =>
                            exportToXLS(
                              "7ea9db6c-fd41-4b08-95f7-dbdac94165ee",
                              true
                            )
                          }
                          endIcon={<FileDownloadOutlinedIcon />}
                          className="export-button"
                        >
                          {!loadingExcel ? (
                            <Box component={"span"}>
                              Exportar Lista Completa
                            </Box>
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </Button>
                      </Tooltip>
                    </div>
                    <NativeObject
                      app={app}
                      key="7ea9db6c-fd41-4b08-95f7-dbdac94165ee"
                      type={"table"}
                      reference={{
                        id: "7ea9db6c-fd41-4b08-95f7-dbdac94165ee",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",

                        width: "100%",
                      }}
                    />
                  </div>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

InsightsGoldenDesktop.defaultProps = {
  app: null,
  config: {},
};

InsightsGoldenDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InsightsGoldenDesktop;
